export default {"src":"/_next/static/media/pic_04.86c9dce7.JPG","height":4000,"width":6000,"blurWidth":0,"blurHeight":0};